import React, { useState } from "react";
import { Button, Card, Col, FloatingLabel, Form, Row, Stack } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { deleteGuardian, deleteMember, postNote, postSummary } from "../../../../services/httpClient";
import DatePicker from "../../../ui/DatePicker";
import SelectObject from "../../../ui/SelectObject";

interface DeleteState {
  userId: string | undefined;
  setIsDeleting: any;
  userToDelete: string | undefined;
  setUserToDelete: any;
  fetchHousehold: any;
  resetHouseholdTab: any;
  type: string;
  caseStatus: string | undefined;
  setShowToast: any;
  setToastText: any;
  setToastBody: any;
}

const ConfirmDelete = ({
  userId,
  setIsDeleting,
  userToDelete,
  setUserToDelete,
  fetchHousehold,
  resetHouseholdTab,
  type,
  caseStatus,
  setShowToast,
  setToastText,
  setToastBody,
}: DeleteState) => {
  const { id } = useParams();
  const [exitDate, setExitDate] = useState<string>(new Date().toISOString().split("T")[0]);
  const [exitNote, setExitNote] = useState<string>();
  const [exitType, setExitType] = useState<string>("voluntary");

  var exitTypes: any[] = [
    { id: 0, key: "voluntary", name: "Voluntary" },
    { id: 1, key: "involuntary", name: "Involuntary" },
  ];

  const onClickDeleteFinalWExit = () => {
    setIsDeleting(false);
    setUserToDelete("");

    if (type === "Guardian") {
      if (caseStatus === "active") {
        const note = {
          notetype: "exit",
          subject: {
            id: userId,
            type: "guardian",
          },
          fields: {
            exit_type: exitType,
            description: exitNote ?? "",
            date: new Date().toISOString().split("T")[0],
          },
        };

        //save exit note
        postNote(note, id)
          .then((res: any) => {
            const noteId = res[0].data.note_id;

            const exitData = {
              exit_at: exitDate,
              exit_note_id: noteId,
            };

            deleteGuardian(id, userId, exitData)
              .then((res: any) => {
                resetHouseholdTab();
                fetchHousehold();
                setShowToast(true);
                setToastText("Guardian Deleted");
                setToastBody(userToDelete);
              })
              .catch((err: any) => {
                console.log(err);
              });

            //create new ai summary
            postSummary(id)
              .then((res: any) => {})
              .catch((err: any) => {
                console.log(err);
              });
          })
          .catch((err: any) => {
            console.log(err);
          });
      }
    } else if (type === "Member") {
      if (caseStatus === "active") {
        const note = {
          notetype: "exit",
          subject: {
            id: userId,
            type: "member",
          },
          fields: {
            exit_type: exitType,
            description: exitNote ?? "",
            date: new Date().toISOString().split("T")[0],
          },
        };

        //save exit note
        postNote(note, id)
          .then((res: any) => {
            const noteId = res[0].data.note_id;

            const exitData = {
              exit_at: exitDate,
              exit_note_id: noteId,
            };

            deleteMember(id, userId, exitData)
              .then((res: any) => {
                resetHouseholdTab();
                fetchHousehold();
                setShowToast(true);
                setToastText("Member Deleted");
                setToastBody(userToDelete);
              })
              .catch((err: any) => {
                console.log(err);
              });

            //create new ai summary
            postSummary(id)
              .then((res: any) => {})
              .catch((err: any) => {
                console.log(err);
              });
          })
          .catch((err: any) => {
            console.log(err);
          });
      }
    }
  };

  const onClickDeleteFinal = () => {
    setIsDeleting(false);
    setUserToDelete("");

    if (type === "Guardian") {
      deleteGuardian(id, userId)
        .then((res: any) => {
          resetHouseholdTab();
          fetchHousehold();
          setShowToast(true);
          setToastText("Guardian Deleted");
          setToastBody(userToDelete);
        })
        .catch((err: any) => {
          console.log(err);
        });
    } else if (type === "Member") {
      deleteMember(id, userId)
        .then((res: any) => {
          resetHouseholdTab();
          fetchHousehold();
          setShowToast(true);
          setToastText("Member Deleted");
          setToastBody(userToDelete);
        })
        .catch((err: any) => {
          console.log(err);
        });
    }
  };

  const onClickCancelDelete = () => {
    setIsDeleting(false);
    setUserToDelete("");
  };

  const updateExitNote = (e: any) => {
    setExitNote(e.target.value);
  };

  const updateExitType = (e: any) => {
    setExitType(e.target.value);
  };

  return (
    <Card className="bg-light mb-3">
      <Card.Body>
        <Stack direction="horizontal" gap={3} className={caseStatus === "active" ? "mb-3" : ""}>
          <Stack style={{ justifyContent: "center" }}>
            <Card.Subtitle>Are you sure you want to delete {userToDelete}?</Card.Subtitle>
          </Stack>
          <Button
            className="app-danger-color button"
            onClick={() => {
              caseStatus === "active" ? onClickDeleteFinalWExit() : onClickDeleteFinal();
            }}
          >
            Confirm Delete
          </Button>
          <div className="vr" />
          <Button className="app-primary-color button" onClick={() => onClickCancelDelete()}>
            Cancel
          </Button>
        </Stack>
        {caseStatus === "active" && (
          <>
            <Row className="mb-3">
              <Col xs={12}>
                <FloatingLabel controlId="floatingInput" label="Exit Note">
                  <Form.Control
                    as="textarea"
                    type="textarea"
                    placeholder="Exit Note"
                    value={exitNote}
                    onChange={(e) => updateExitNote(e)}
                  />
                </FloatingLabel>
              </Col>
            </Row>
            <Row>
              <Col xs={8}>
                <SelectObject label="Exit Type" value={exitType} options={exitTypes} onUpdate={(e: any) => updateExitType(e)} />
              </Col>
              <Col xs={4}>
                <DatePicker label="Exit Date" currentValue={exitDate} setCurrentValue={setExitDate} hasMaxDate={true} />
              </Col>
            </Row>
          </>
        )}
      </Card.Body>
    </Card>
  );
};

export default ConfirmDelete;
